import { useBlockProps } from '@wordpress/block-editor';
import testimonial from './Frame-47.png';
export default function Save({ attributes }) {
    const { bgImage, titleText, descriptionText, buttonText, buttonUrl, testimonialText, authorName, authorImage } = attributes;

    return (
        <div {...useBlockProps.save()} style={{ backgroundImage: `url(${bgImage})` }} className="testimonial-block">
            <div className="testimonial-left">
                <h3>Testimonial</h3>
                <h2>{titleText}</h2>
                <p>{descriptionText}</p>
                <a href={buttonUrl} className="testimonial-btn">
                    {buttonText}
                    <i class="fas fa-arrow-right"></i>
                </a>
            </div>
            <div className="testimonial-right">
                <div className="testimonial-content">
                    <img src={testimonial}></img>
                    <p>{testimonialText}</p>
                    <div className="testimonial-author">
                        {authorImage && <img src={authorImage} alt={authorName} />}
                        <p>{authorName}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
